import axios from "axios";
import { getCookie } from "../utils/service";

const Axioscall = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

Axioscall.interceptors.request.use((req) => {
  const accessToken = getCookie("x-access-token");
  req.headers.Authorization = accessToken ? `${accessToken}` : "";
  return req;
});
export default Axioscall;
